
export const navigation = {
  
  brand:      'reactDirectorAdmin',
  leftLinks:  [],
  rightLinks: [
    {
      label:      'Home',
      link:       '/',
      view:       'home',
      isRouteBtn: true
    },
    {
      label:      'About',
      link:       '/about',
      view:       'about',
      isRouteBtn: true
    }
  ],
 
  mainNavigation : {
    'superadmin' : [
      {
        id: 1,
        group: 'Dashboard',
        menus: [
          {
            name: 'Dashboard',
            linkTo: '/home',
            faIconName: 'fa-home'
         }
        ]
      },
      {
        id: 2,
        group: 'Manage',
        menus: [
          {
            name: 'Cities',
            linkTo: '/cityAndCountry',
            faIconName: 'fa-eye'
          },
          {
            name: 'Sites',
            linkTo: '/',
            faIconName: 'fa-eye',
            submMenu: {
              id: 41,
              group: 'Sites',
              menus: [
                {
                    name: 'View Active',
                    linkKey: 'VIEW_ACTIVE',
                    linkTo: '/viewSiteList',
                    faIconName: 'fa-eye'
                  },
                  {
                    name: 'View Inactive',
                    linkKey: 'VIEW_INACTIVE',
                    linkTo: '/viewSiteInactiveList',
                    faIconName: 'fa-eye'
                  }
              ]
            }
          },
          {
            name: 'SSL Certs',
            linkTo: '/ssl/list',
            faIconName: 'fa-globe'
          },
          {
            name: 'Users',
            linkTo: '/',
            faIconName: 'fa-eye',
            submMenu: {
              id: 42,
              group: 'Users',
              menus: [
                {
                    name: 'Super Admin Users',
                    linkKey: 'SUPER_ADMIN_USERS',
                    linkTo: '/superadmin/list',
                    faIconName: 'fa-eye'
                  },
                  {
                    name: 'Sub Admin Users',
                    linkKey: 'SUB_ADMIN_USERS',
                    linkTo: '/subadmin/list',
                    faIconName: 'fa-eye'
                  },
                  {
                    name: 'Force Password Update',
                    linkKey: 'FORCE_PASSWORD_UPDATE',
                    linkTo: '#',
                    faIconName: 'fa-eye'
                  }
              ]
            }
          }
        ]
      },
      {
        id: 3,
        group: 'Announcements',
        menus: [
          {
            name: 'Create New',
            linkKey: 'CREATE_NEW',
            linkTo: '/AddAnnouncements',
            faIconName: 'fa-eye'
          },
          {
            name: 'View Announcements',
            linkKey: 'VIEW_ANNOUNCEMENTS',
            linkTo: '/announcements',
            faIconName: 'fa-eye'
          },
          {
            name: 'Create Banners',
            linkKey: 'CREATE_BANNERS',
            linkTo: '/AddBanners',
            faIconName: 'fa-eye'
          },  
          {
            name: 'View Banners',
            linkKey: 'VIEW_BANNERS',
            linkTo: '/banners',
            faIconName: 'fa-eye'
          }
        ]
      },
      {
        id: 4,
        group: 'Reports',
        menus: [
          {
            name: 'Invoices',
            linkTo: '/',
            faIconName: 'fa-eye',
            submMenu: {
              id: 43,
              group: 'Invoices',
              menus: [
                {
                    name: 'Create New',
                    linkKey: 'CREATE_INVOICE',
                    linkTo: '/AddInvoices',
                    faIconName: 'fa-eye'
                  },
                  {
                    name: 'View Paid',
                    linkKey: 'VIEW_PAID',
                    linkTo: '/PaidInvoices',
                    faIconName: 'fa-eye'
                  },
                  {
                    name: 'View Unpaid',
                    linkKey: 'VIEW_UNPAID',
                    linkTo: '/invoices',
                    faIconName: 'fa-eye'
                  },
                   {
                    name: 'Invoices Report',
                    linkKey: 'VIEW_UNPAID',
                    linkTo: '/InvoiceReport',
                    faIconName: 'fa-eye'
                  },
              ]
            }
          },
          {
            name: 'Monthly Performance',
            linkTo: '/report/sales',
            faIconName: 'fa-globe'
          },
          {
            name: 'Payout By Offer Per Site',
            linkTo: '#',
            faIconName: 'fa-eye'
          },
          {
            name: 'Refunds Per Site',
            linkTo: '#',
            faIconName: 'fa-eye'
          },
          {
            name: 'Revenue Per Site',
            linkTo: '/report/revenueSite',
            faIconName: 'fa-eye'
          }
        ]
      }
    ]
   }
};



// WEBPACK FOOTER //
// ./src/app/models/navigation.js